let isDebug = process.env.ENV == "development";
export default {
  razorpayToken: isDebug
    ? "rzp_test_JExadwAHAOD4ii"
    : "rzp_live_LB44BUnHaV6Ok8",
  googleTrackingId: "UA-150203990-10",
};
